import { render, staticRenderFns } from "./BrandModal.vue?vue&type=template&id=313003f5&scoped=true&"
import script from "./BrandModal.vue?vue&type=script&lang=js&"
export * from "./BrandModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandModal.vue?vue&type=style&index=0&id=313003f5&scoped=true&lang=css&"
import style1 from "./BrandModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313003f5",
  null
  
)

export default component.exports